// The dialog's key-hint strip. Two columns at the
// top of the drawer: the in-dialog command keys (left) and the always-on live-strip
// keys (right), so the keyboard needs no on-screen labels — the canvas stays clean
// for physical-key alignment. Reposition-only: no oversized or highlighted controls.

interface Binding {
  key: string;
  action: string;
}

/** In-dialog command keys (modeless: ←/→ dial the focused control, no edit mode). */
const COMMAND: Binding[] = [
  { key: "↑ ↓", action: "Move" },
  { key: "← →", action: "Adjust" },
  { key: "●", action: "Select" },
  { key: "✕", action: "Close" },
];

/** Always-on live strip — works any time, dialog open or not. Mirrors
 *  DEFAULT_PIANO_CONTROL.liveKeys (C♯2…A2). */
const LIVE: Binding[] = [
  { key: "C♯2", action: "🎓 Coach" },
  { key: "D2", action: "⟲ Restart" },
  { key: "D♯2", action: "▶ Play it for me" },
  { key: "E2", action: "▶❚ Play" },
  { key: "F2 G2", action: "∓ Tempo" },
  { key: "F♯2", action: "🥁 Metronome" },
  { key: "G♯2", action: "A/B loop" },
  { key: "A2", action: "⏺ Record" },
];

function row(b: Binding): HTMLElement {
  const el = document.createElement("div");
  el.className = "legend-row";
  const key = document.createElement("kbd");
  key.textContent = b.key;
  const action = document.createElement("span");
  action.textContent = b.action;
  el.append(key, action);
  return el;
}

function group(title: string, bindings: Binding[]): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "legend-group";
  const head = document.createElement("div");
  head.className = "legend-head";
  head.textContent = title;
  wrap.append(head, ...bindings.map(row));
  return wrap;
}

/** The dialog's top key-hint strip: command keys (left) · always-on keys (right). */
export function buildKeyHints(): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "key-hints";
  wrap.append(group("Command keys", COMMAND), group("Always-on keys", LIVE));
  return wrap;
}
